export const Logo = () => (
  <>
    <span>Fit</span>
    <span className="-ml-[2px] italic text-amber-500">Zero</span>
  </>
)
